module.exports = __webpack_public_path__ + "cc22112198f5584848b85644242fc214.png";